 // eslint-disable-next-line no-restricted-globals
import React, { useContext, useEffect, useState } from 'react';

import { Button, ModalWindow } from './components/atoms';
import { AuthService } from './services';

import { default as t } from './utils/i18n';
import { useHistory } from 'react-router-dom';


// context
import { UserContext } from './context';
import axios from 'axios';

function RefreshHandler () {
  let stateObject = {}
  const { user, setUser } = useContext(UserContext);
  const userAccessToken = user?.tokens?.accessToken?.jwtToken || stateObject?.tokens?.accessToken?.jwtToken;
  const refreshToken = user?.tokens?.refreshToken;
  const username = user?.username || stateObject?.username;
  const [authenticated, setAuthenticated] = useState(user?.authenticated);
  const [showSignedOutModal, setShowSignedOutModal] = useState(false);
  const history = useHistory();

 
  useEffect(() => {


     axios.interceptors.request.use(
      function (config) {
       
        if(stateObject?.isSSO || user?.isSSO) {
          config.headers["x-source"] ="sso";
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    async function verifyTheSession () {
      ////console.log('Verifying the access token...');
      try {
        await AuthService.verifySession(username?.toLowerCase(), userAccessToken);
      } catch (error) {
        setShowSignedOutModal(true);
        setAuthenticated(false);
        const dataCode = error?.data?.data?.code;
        ////console.log('Error while verifying the access token...', dataCode);
        if (dataCode === 'CL_USR_009' || dataCode === 'CL_USR_000' || dataCode === 'CL_USR_007') {
          setUser(prevUserState => ({
            ...prevUserState,
            authenticated: false,
          }));
          setShowSignedOutModal(true);
        }
      }
    }
    if (user?.authenticated) {
      verifyTheSession();
    }
  }, []);

  useEffect(() => {
    async function refreshTheToken() {
      ////console.log('Refreshing the tokens...');

      try {
        const refreshTokenResponse = await AuthService.refreshSession(
          username.toLowerCase(),
          refreshToken,
          user?.isSSO
        );
        const tokens = refreshTokenResponse.data?.data;
        setUser(prevUserState => ({
          ...prevUserState,
          tokens,
          authenticated: true,
        }));
      } catch (error) {
        setShowSignedOutModal(true);
        setAuthenticated(false);
        const dataCode = error?.data?.data?.code;
        ////console.log(dataCode);
        if (dataCode === 'CL_USR_009' || dataCode === 'CL_USR_000' || dataCode === 'CL_USR_007') {
          setShowSignedOutModal(true);
        } else {
          history.push('/signIn');
          localStorage.removeItem('user');
          setUser(null);
        }
      }
    }
    const MILLIS_10_MINS = 10 * 60 * 1000;
    let refreshInterval;
    if (user?.authenticated) {
      refreshInterval = setInterval(refreshTheToken, MILLIS_10_MINS);
    }

    return () => {
      clearInterval(refreshInterval);
    };
  }, [authenticated]);

  useEffect(() => {
    document.body.style.backgroundColor = '#ffffff';
  });

  const handleOnReload = () => {
    setShowSignedOutModal(false);
    localStorage.removeItem('user');
    setUser(null);
    history.push('/signIn');
  };

  //loader usereffects

  return (
    <ModalWindow
      className="fqa-modal--notification"
      isOpen={showSignedOutModal}
      heading={t('dashboard.modal.text.signInAgain')}
    >
      <h3 className="fqa-model-dash--message">{t('dashboard.modal.text.youWereSignedOut')} </h3>
      <div className="fqa-model-dash--actions">
        <Button
          className="fqa-model-dash--actions-reload"
          label={t('user.buttonText.reload')}
          handleClick={handleOnReload}
        />
      </div>
    </ModalWindow>
  );
}

export default RefreshHandler;
